<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      hide-header
      no-close-on-esc
      title="EFT Terminal"
      ref="eft_tim_terminal_functions"
      id="eft_tim_terminal_functions"
      centered
    >

    <div class="eftCalls">
       <div class="row w-75">
          <div class="col-6 mb-3 p-1">
            <button class="fn-btn" @click="callFunction('balance')">Daily Closure (Balance)</button>
          </div>
          <div class="col-6 mb-3 p-1">
            <button class="fn-btn" @click="callFunction('closeTerminal')">Close Terminal</button>
          </div>
          <!-- <div class="col-4 mb-3 p-1">
            <button class="fn-btn" @click="callFunction('Credit')">Credit</button>
          </div>
          <div class="col-4 p-1">
            <button class="fn-btn" @click="callFunction('cancel')">Cancel</button>
          </div>
          <div class="col-4 p-1">
            <button class="fn-btn" @click="callFunction('rollback')">Rollback</button>
          </div> -->
       </div>
    </div>    
    </b-modal>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index.js";
import Nav from "@/Nav";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { backendSocket, EventBus } from "@/main.js";

export default {
  props: {},
  components: {
    Vkeyboard,
    VkeyboardFloat
  },
  data() {
    return {
       keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
      },
    };
  },
  computed: {},
  beforeMount() {
  },
  mounted() {},
  methods: {
   callFunction(type) {
    console.log('callFunction', type.toLowerCase());
    if(type.toLowerCase() == 'balance') {
      balance()
    } else if(type.toLowerCase() == 'credit') {
      credit()
    } else if(type.toLowerCase() == 'reversal') {
      reversal()
    } else if(type.toLowerCase() == 'cancel') {
      cancel()
    } else if(type.toLowerCase() == 'rollback') {
      rollback()
    } else if(type.toLowerCase() == 'credit') {
      credit()
    } else if(type.toLowerCase() == 'closeterminal') {
      console.log('closeTerminal clicked');
      deactivate();
    }
   }
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.settings-box {
  font-size: 12px;
  font-weight: bold;
}

.fn-btn {
    height: 101px;
    border: none;
    border-radius: 15px;
    box-shadow: 0px 1px 5px 0px grey;
    font-weight: 500;
    font-size: 18px;
    transition: 0.3s ease;
    width: 100%;
    padding: 0px 0;
    font-size: 12px;
    cursor: pointer;
    -webkit-transition: 0.3s ease;
    transition: 0.3s ease;
    background-color: #c2d5e8;
    font-size: 16px;
    font-weight: bold;
}

#eft_tim_terminal_functions___BV_modal_content_ {
  background: transparent;
  border:none
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/EFTFunctionsPopup.vue